import React, { useState } from 'react'
import { Modal, Button, Form } from 'semantic-ui-react'
import { useTextResources } from '../../language'
import PropTypes from "prop-types";

const AddFolioPopup = ({onCancel, onSave, reservation, ...rest})=>{
    const text = useTextResources()
    const [entity, setEntity] = useState()
    const closeAction = ()=>{
        if (onCancel){
            onCancel()
        }
    }
    const saveAction = ()=>{
        if (onSave) {
            onSave(entity)
        }
    }
    const options = []
    if (reservation && reservation.GuestId) {
        options.push({
            text: "Guest",
            value: 1,
            key: 1
        })
    }
    if (reservation && reservation.CompanyID) {
        options.push({
            text: "Company",
            value: 3,
            key: 3
        })
    }
    if (reservation && reservation.AgentID) {
        options.push({
            text: "Agent",
            value: 2,
            key: 2
        })
    }
    return <Modal size="mini" {...rest}>
        <Modal.Header>{text("AddFolio")}</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Select label={text("FolioOwner")} options={options} onChange={(e, {value})=>setEntity(value)}></Form.Select>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button size={"small"} negative onClick={closeAction}>{text("Cancel")}</Button>
            <Button disabled={!entity} size={"small"} positive onClick={saveAction}>{text("Add")}</Button>
        </Modal.Actions>
    </Modal>
}
AddFolioPopup.propTypes = {
    onSave: PropTypes.func,
    onCancel: PropTypes.func,
    reservation: PropTypes.any
}

export default AddFolioPopup